/* eslint-disable react/prop-types */
import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import PropTypes from 'prop-types';

export const Size = Object.freeze({
  L: 60,
  M: 30,
  S: 10,
});

export const Color = Object.freeze({
  White: 'white',
  Black: 'black',
  Violet: '#645aff',
});

const Spinner = ({ color, size, className }) => (
  <div className={className}>
    <ClipLoader color={color} size={size} />
  </div>
);

Spinner.propTypes = {
  color: PropTypes.oneOf(Object.values(Color)),
  size: PropTypes.oneOf(Object.values(Size)),
  className: PropTypes.string,
};

Spinner.defaultProps = {
  color: Color.Violet,
  size: Size.M,
  className: '',
};

export default Spinner;
